var _dec, _class;

/** @module components/MetaBox */
import React from "react";
import $ from "jquery";
import { observer, inject } from "mobx-react";
import { Icon } from "react-aiot";
import { request, hooks, rmlOpts, i18n, getMediaDialogNextZIndex } from "../util";
import FolderBox, { FolderBoxHeader } from "./FolderBox";
import { Modal } from ".";
import store from "../store";
import { clone } from "mobx-state-tree";
/**
 * Show a meta box for the selected folder id. It also supports
 * user settings.
 *
 * @property {string|int} id The id of the folder or 'usersettings'
 * @extends React.Component
 */

let MetaBox = (_dec = inject("store"), _dec(_class = observer(_class = class MetaBox extends React.Component {
  constructor(props) {
    super(props);

    this.handleRef = ref => {
      this.refSpan = ref;
      /**
       * The MetaBox ref element is ready and created.
       *
       * @event module:util/hooks#folder/meta
       * @param {HTMLElement} ref The reference
       * @param {string|id} id The folder id or 'usersettings'
       * @param {module:store~Store} store The store
       * @this MetaBox instance
       */

      hooks.call("folder/meta", [ref, this.state.id, this.props.store], this);
    };

    this.handleSave = async () => {
      const form = $(this.refSpan).children("form"),
            serialize = form.serializeArray(),
            data = {};
      $.each(serialize, (key, value) => data[value.name] = value.value);
      /**
       * The MetaBox is serialized and ready to send.
       *
       * @event module:util/hooks#folder/meta/serialize
       * @param {string|id} id The folder id or 'usersettings'
       * @param {module:store~Store} store The store
       * @param {object} data The data prepared for the server so you can perhaps modify it
       * @param {HTMLElement} form The form container
       * @this MetaBox instance
       */

      hooks.call("folder/meta/serialize", [this.state.id, this.props.store, data, form], this);

      try {
        const response = await request({
          location: {
            path: this.state.id === "usersettings" ? "/usersettings" : "/folders/" + this.state.id + "/meta",
            method: "PUT"
          },
          request: data
        });
        /**
         * The MetaBox is saved successfully.
         *
         * @event module:util/hooks#folder/meta/saved
         * @param {string|id} id The folder id or 'usersettings'
         * @param {object} response The server response
         * @param {object} data The data sent to the server
         * @this MetaBox instance
         */

        hooks.call("folder/meta/saved", [this.state.id, response, data], this);
        this.props.onClose(true, response);
      } catch ({
        responseJSON: {
          message
        }
      }) {
        this.setState({
          errors: message
        });
      } finally {
        this.setState({
          loading: false
        });
      }
    };

    this.state = {
      id: 0,
      // The current visible id
      html: "",
      // The html
      loading: false,
      errors: []
    };
  }

  componentDidUpdate() {
    const {
      id
    } = this.props;

    if (id !== this.state.id) {
      this.setState({
        id,
        html: ""
      });

      if (id !== false) {
        request({
          location: {
            path: id === "usersettings" ? "/usersettings" : "/folders/" + id + "/meta"
          }
        }).then(({
          html
        }) => {
          this.setState({
            html
          });
        }, () => {
          // An error occured
          this.setState({
            html: ""
          });
        });
      }
    }
  }

  render() {
    let selected, modalContent, title;

    if (this.props.id === "usersettings") {
      selected = {
        icon: /*#__PURE__*/React.createElement(Icon, {
          type: "setting"
        }),
        title: rmlOpts.others.lang.userSettingsToolTipTitle
      };
    } else {
      selected = this.props.store.getTreeItemById(this.props.id, false);
    }

    const {
      html,
      loading,
      errors
    } = this.state;

    if (selected) {
      title = /*#__PURE__*/React.createElement(FolderBoxHeader, {
        icon: /*#__PURE__*/React.createElement(Icon, {
          type: "ellipsis"
        }),
        folder: selected
      });
      modalContent = /*#__PURE__*/React.createElement(FolderBox, {
        busy: !html || loading,
        folder: selected,
        errors: errors,
        header: false
      }, html && /*#__PURE__*/React.createElement("div", {
        className: "inside"
      }, /*#__PURE__*/React.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: html
        },
        style: {
          display: html ? "block" : "none"
        },
        ref: this.handleRef
      })));
    }

    return /*#__PURE__*/React.createElement(Modal, {
      visible: !!modalContent,
      title: title,
      onOk: this.handleSave,
      onCancel: this.props.onClose,
      cancelText: i18n("cancel"),
      okText: i18n("save"),
      zIndex: getMediaDialogNextZIndex(),
      confirmLoading: loading
    }, modalContent);
  }

}) || _class) || _class);
/**
 * Wait for the input field for the cover image and create a media picker.
 *
 * @see https://wordpress.stackexchange.com/questions/190987/how-do-i-create-a-custom-add-media-button-modal
 */

hooks.register("wprfc/metaCoverImage", function () {
  const modal = $(this).parents(".ant-modal-wrap").parent(),
        {
    _frame
  } = $(this).wpMediaPicker().data("wpWpMediaPicker"); // Attach new store with new selected id

  const useStore = clone(store);
  useStore.getTreeItemById("all", false).setter(node => node.selected = true);

  _frame.$el.data("useStore", useStore); // Listen to changes


  _frame.on("open", () => modal.hide()).on("close", () => modal.show());
});
export default MetaBox;